import SkeletonBar from "../shared/SkeletonBar";

export function PaymentListCardSkeleton() {
    return (
        <article
            className="rounded-xl border border-slate-200 bg-white p-4 md:p-5"
            aria-hidden
        >
            <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                <div className="min-w-0 flex-1 space-y-2">
                    <div className="flex flex-wrap items-center gap-2">
                        <SkeletonBar className="h-5 w-32" />
                        <SkeletonBar className="h-5 w-20 rounded-full" />
                    </div>
                    <div className="flex flex-wrap items-center gap-2">
                        <SkeletonBar className="h-4 w-28" />
                        <SkeletonBar className="h-4 w-40" />
                    </div>
                </div>
                <div className="flex shrink-0 flex-col items-start gap-2 sm:items-end">
                    <SkeletonBar className="h-6 w-20" />
                    <SkeletonBar className="h-4 w-16" />
                </div>
            </div>
        </article>
    );
}

export default function PaymentListSkeletons({
    count = 5,
    className = "",
    label = "Loading payments",
}) {
    return (
        <div
            className={`min-w-0 w-full space-y-3 ${className}`.trim()}
            aria-busy="true"
            aria-label={label}
            role="status"
        >
            <span className="sr-only">{label}</span>
            {Array.from({ length: count }, (_, index) => (
                <PaymentListCardSkeleton key={index} />
            ))}
        </div>
    );
}
